define('LazyLoad.Shopping', [
  'Home.View',
  'ProductDetails.ImageGallery.View',
  'Facets.Browse.View',
  'GoogleTagManager',
  'underscore',
  'jQuery',
  'Utils',
  'Facets.FacetedNavigationItem.View'
], function (
  HomeView,
  ProductDetailsImageGalleryView,
  FacetsBrowseView,
  GoogleTagManager,
  _,
  $,
  Utils,
  FacetsFacetedNavigationItemView
) {
  'use strict';

  function prepareIframes() {
    $('iframe[src]').each(function (index, element) {
      $(element).attr('data-src', $(element).attr('src'));
      $(element).removeAttr('src');
    });
  }

  function userInteracts() {
    $('iframe[data-src]').each(function (index, element) {
      $(element).attr('src', $(element).attr('data-src'));
      $(element).removeAttr('data-src');
    });
    window.bxSlider && window.bxSlider.startAuto && window.bxSlider.startAuto();
  }

  function setGTMinit() {
    // eslint-disable-next-line no-undef
    var gtmjs = _.find(dataLayer, function (event) {
      return event.event === 'gtm.js';
    });
    if (gtmjs) {
      gtmjs.lazyLoading = { active: true };
    }
  }

  GoogleTagManager.pushData = _.wrap(GoogleTagManager.pushData,
    function wrapPushDataFunction(fn) {
      fn.apply(this, _.toArray(arguments).slice(1));
      setGTMinit();
    }
  );

  return {
    mountToApp: function mountToApp(container) {
      var Layout = container.getComponent('Layout');
      Layout.on('afterShowContent', function () {
        prepareIframes();
        $(document.body).on('touchmove', onInteraction);
        $(window).on('scroll mouseover', onInteraction);
        function onInteraction() {
          $(document.body).off('touchmove', onInteraction);
          $(window).off('scroll mouseover', onInteraction);
          userInteracts();
          GoogleTagManager.pushData({event: 'userInteraction', lazyLoading: { active: false }});
        }
      });
      _.extend(ProductDetailsImageGalleryView.prototype, {
        initialize: _.wrap(ProductDetailsImageGalleryView.prototype.initialize, function wrapNextImageEventHandler(fn) {
          var loaded = false;
          var self = this;
          this.on('afterViewRender', function () {
            // lazyLoad slider
            $(document.body).on('touchmove', onInteraction);
            $(window).on('scroll mouseover', onInteraction);

            function onInteraction() {
              self.loadImages();
              if (!loaded) {
                loaded = true;
                GoogleTagManager.pushData({event: 'userInteraction', lazyLoading: { active: false }});
              }
            }
          });

          fn.apply(this, _.toArray(arguments).slice(1));
        }),
        loadImages: function loadImages() {
          userInteracts();
          $('.product-details-image-gallery-container').attr('data-zoom', '');
        }
      });

      _.extend(FacetsFacetedNavigationItemView.prototype, {
        getContext: _.wrap(FacetsFacetedNavigationItemView.prototype.getContext, function (fn) {
          if (!SC.isPageGenerator()) {
            return fn.apply(this, _.toArray(arguments).slice(1));
          }
        })
      });

      _.extend(FacetsBrowseView.prototype, {
        initialize: _.wrap(FacetsBrowseView.prototype.initialize, function wrapInitialize(fn) {
          var loaded = false;
          this.on('afterViewRender', function () {
            // lazyLoad slider
            $(document.body).on('touchmove', onInteraction);
            $(window).on('scroll mouseover', onInteraction);

            function onInteraction() {
              userInteracts();
              if (!loaded) {
                loaded = true;
                GoogleTagManager.pushData({event: 'userInteraction', lazyLoading: { active: false }});
              }
            }
          });

          fn.apply(this, _.toArray(arguments).slice(1));
        })
      });

      _.extend(HomeView.prototype, {
        initSlider: function initSlider() {
          window.bxSlider = Utils.initBxSlider(this.$('[data-slider]'), {
            nextText: '<a class="home-gallery-next-icon"></a>',
            prevText: '<a class="home-gallery-prev-icon"></a>',
            onSliderLoad: function () {
              $('.home-image-slider li .home-slide-caption').show();
            }
          });
        },
        initialize: _.wrap(HomeView.prototype.initialize, function wrapInitialize(fn) {
          var loaded = false;
          this.on('afterViewRender', function () {
            // lazyLoad slider
            $(document.body).on('touchmove', onInteraction);
            $(window).on('scroll mouseover', onInteraction);

            function onInteraction() {
              userInteracts();
              if (!loaded) {
                loaded = true;
                GoogleTagManager.pushData({event: 'userInteraction', lazyLoading: { active: false }});
                // loadScripts();
              }
            }
          });

          fn.apply(this, _.toArray(arguments).slice(1));
        })
      });
    }
  };
});
